import {useSelector} from "react-redux";
import {Navigate} from "react-router-dom";
import {RootState} from "../../redux/store";

/**
 * Where `/` sends people.
 *
 * The marketing site is served elsewhere, so the app root is purely a
 * redirect. It stays session-aware — signed-in users land on their own
 * dashboard rather than being bounced to a login form they don't need,
 * which is what the old marketing landing page did before it was removed.
 */
export default function RootRedirect() {
  const {userInfo} = useSelector((state: RootState) => state.userLogin);

  const isCustomer = userInfo && userInfo.isCustomer;
  const isCoach = userInfo && !userInfo.isCustomer;

  return (
    <Navigate
      replace
      to={isCustomer ? "/customer/home" : isCoach ? "/onboarding" : "/auth/login"}
    />
  );
}
